import type { ISlide, ISlideData } from './slide.types';

export * from './slide.types';

export class Slide implements ISlide {
  id: string = '';
  header: string = '';
  description: string = '';
  imageUrl: string = '';
  order: number = 0;
  primaryActionUrl?: string | undefined;

  constructor(data: ISlideData) {
    if (data) {
      this.id = data.id;
      this.header = data.header;
      this.description = data.description;
      this.imageUrl = data.imageUrl;
      this.order = data.order;
      this.primaryActionUrl = data.primaryActionUrl;
    }
  }
}
